import {
  Link
} from "gatsby";
import './Header.css'
const Header = () => (
  <nav className="navbar navbar-expand-lg navbar-light bg-white sticked">
    <div className="container-fluid">
      <Link style={{ marginRight: "3rem" }} className="navbar-brand" to="/">
        {/* LOGO */}
        <img src="BizdamnLogo.svg" alt="Bizdamn Logo" style={{ width: "3rem", margin: "0rem" }} />
        <img src="HeaderName.svg" alt="Bizdamn Logo" style={{ width: "10rem", margin: "0rem" }} />
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-mdb-toggle="collapse"
        data-mdb-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i className="fas fa-bars"></i>
      </button>
      <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div className="navbar-nav">
          <ul className="navbar-nav d-flex ">
            <li className="m-auto">
              <Link  className="mx-3 nav-link btn-outline-primary" to="/website-packages">Packages</Link>
            </li>
            <li className="m-auto">
              <Link  className="mx-3 nav-link hvr-underline-from-left" to="/blog">Blog</Link>
            </li>
            <li className="m-auto">
              <Link  className="mx-3 nav-link hvr-underline-from-left" to="/services">Services</Link>
            </li>
            <li className="m-auto">
              <Link  className="mx-3 nav-link hvr-underline-from-left" to="/resources">Resources</Link>
            </li>
            <li className="m-auto">
              <Link  className="mx-3 nav-link hvr-underline-from-left" to="/graphic-templates">Graphic Templates</Link>
            </li>
            <li className="m-auto">
              <Link  className="mx-3 nav-link hvr-underline-from-left" to="/guides">Guides</Link>
            </li>
           
          </ul>
        </div>
      </div>
    </div>
  </nav>






);
export default Header;






